import { Paper, Skeleton, Stack, Switch, Text, Title } from "@mantine/core";
import type { NotificationEventType } from "@yalana/contracts";
import { useTranslation } from "react-i18next";
import { useNotificationPreferences } from "../hooks/useNotificationPreferences";

export function NotificationPreferences() {
  const { t } = useTranslation();
  const { preferences, isLoading, toggle, isSaving } =
    useNotificationPreferences();

  if (isLoading) {
    return (
      <Paper withBorder p="lg" radius="md">
        <Stack gap="md">
          <Skeleton height={24} width="60%" />
          <Skeleton height={36} />
          <Skeleton height={36} />
        </Stack>
      </Paper>
    );
  }

  return (
    <Paper withBorder p="lg" radius="md">
      <Title order={3} mb="xs">
        {t("notifications.preferences.title")}
      </Title>
      <Text c="dimmed" size="sm" mb="md">
        {t("notifications.preferences.description")}
      </Text>

      <Stack gap="sm">
        {preferences.map((pref) => (
          <Switch
            key={pref.eventType}
            label={t(
              `notifications.preferences.${pref.eventType}` as `notifications.preferences.${NotificationEventType}`,
            )}
            checked={pref.enabled}
            onChange={(e) => toggle(pref.eventType, e.currentTarget.checked)}
            disabled={isSaving}
            data-testid={`notification-pref-${pref.eventType}-toggle`}
          />
        ))}
      </Stack>
    </Paper>
  );
}
